import React from 'react'

const Question = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/question',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(7.778 6)'>
        <path
          d='M0 2.16C0 .943 1.016-.048 2.235.003A2.17 2.17 0 0 1 4.343 2.11a2.18 2.18 0 0 1-1.32 2.057c-.509.229-.863.686-.863 1.244'
          stroke={secondaryColor}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <circle fill={secondaryColor} fillRule='nonzero' cx={2.133} cy={7.911} r={1} />
      </g>
      <path
        d='M10 18c-4.414 0-8-3.586-8-8s3.586-8 8-8 8 3.586 8 8-3.586 8-8 8z'
        stroke={primaryColor}
        strokeWidth='1.2'
      />
    </g>
  </svg>
)

export default Question
